import { UsuarioPageNav } from "./Nav";

export const ConsultasNav = () => <UsuarioPageNav
	title="Consultas"
	links={[{
		key: "cont",
		href: "/consultas",
		text: "Minhas contribuições",
	}]}
/>